var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"block":_vm.block,"color":_vm.color,"dark":""},on:{"click":_vm.onShare}},[_c('v-icon',{staticClass:"mr-2",attrs:{"x-small":""}},[_vm._v("fab fa-facebook-f")]),_vm._v(" "+_vm._s(_vm.$t('Facebook'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }